<div class="container job-offer mt-2" style="min-width: 320px; max-width: 72vw">
  <div
    class="overflow-scroll overflow-x-hidden pe-4 mb-5"
    style="height: calc(100vh - 60px)"
  >
    <div class="">
      <h2 class="fs-5 fw-bold">Proposta de Trabalho</h2>

      <div class="w-100 border-bottom">
        <ul class="nav d-flex gap-3">
          <li class="nav-item">
            <a
              style="cursor: pointer"
              (click)="toggleTab('deliveries')"
              class="nav-link ps-2 pb-3 border-primary fw-medium text-decoration-none"
              [ngClass]="[
                selectedTab == 'deliveries' ? 'border-bottom' : '',
                selectedTab == 'deliveries' ? 'text-primary' : 'text-black'
              ]"
              >Entregas e Benefícios</a
            >
          </li>
          <li class="nav-item">
            <a
              style="cursor: pointer"
              (click)="toggleTab('investments')"
              class="nav-link pb-3 border-primary text-decoration-none fw-medium"
              [ngClass]="[
                selectedTab == 'investments' ? 'border-bottom' : '',
                selectedTab == 'investments' ? 'text-primary' : 'text-black'
              ]"
              >Investimento</a
            >
          </li>
        </ul>
      </div>

      <div >
        <app-deliveries *ngIf="selectedTab === 'deliveries'"></app-deliveries>
        <app-investiments *ngIf="selectedTab === 'investments'"></app-investiments>
      </div>
      
    </div>
  </div>
  <div
    class="w-100 footer position-fixed bottom-0 border-top mb-2"
    style="max-width: 70vw; background-color: #f9f9fb"
  >
    <div class="m-2">
      <footer class="pt-3">
        <div class="d-flex justify-content-between align-items-center gap-4">
          <button
            *ngIf="selectedTab === 'deliveries'"
            id="backToObjectiveCollectData"
            routerLink="/collect-data"
            class="d-flex gap-2 btn text-primary"
          >
            <svg
              class=""
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M20.8004 7.79626C21.8412 9.97295 22.0387 12.458 21.355 14.7718C20.6713 17.0856 19.1547 19.0641 17.098 20.3255C15.0413 21.5869 12.5902 22.0417 10.2179 21.6022C7.84557 21.1627 5.72013 19.86 4.25179 17.9455C2.78344 16.0311 2.0763 13.6406 2.26682 11.2354C2.45735 8.83024 3.53204 6.5809 5.28348 4.92151C7.03492 3.26211 9.33895 2.3103 11.7509 2.24978C14.1628 2.18925 16.5117 3.0243 18.3442 4.59376L20.4695 2.46751C20.6102 2.32678 20.8011 2.24771 21.0001 2.24771C21.1991 2.24771 21.39 2.32678 21.5307 2.46751C21.6715 2.60824 21.7505 2.79911 21.7505 2.99813C21.7505 3.19715 21.6715 3.38803 21.5307 3.52876L12.5307 12.5288C12.39 12.6695 12.1991 12.7486 12.0001 12.7486C11.8011 12.7486 11.6102 12.6695 11.4695 12.5288C11.3288 12.388 11.2497 12.1972 11.2497 11.9981C11.2497 11.7991 11.3288 11.6082 11.4695 11.4675L14.0682 8.86876C13.3639 8.40296 12.5231 8.1885 11.6817 8.26008C10.8404 8.33166 10.0478 8.6851 9.43231 9.26318C8.81683 9.84126 8.41446 10.6101 8.29034 11.4454C8.16622 12.2806 8.32762 13.1332 8.7484 13.8653C9.16919 14.5974 9.82473 15.166 10.6089 15.4792C11.3931 15.7923 12.26 15.8316 13.0693 15.5908C13.8786 15.3499 14.5829 14.843 15.0683 14.152C15.5536 13.461 15.7915 12.6265 15.7435 11.7834C15.738 11.685 15.7519 11.5863 15.7845 11.4932C15.8171 11.4001 15.8677 11.3143 15.9334 11.2408C15.9991 11.1672 16.0787 11.1073 16.1676 11.0645C16.2564 11.0217 16.3529 10.9968 16.4514 10.9913C16.6503 10.9801 16.8455 11.0484 16.994 11.1811C17.0676 11.2468 17.1275 11.3264 17.1703 11.4153C17.2131 11.5041 17.238 11.6006 17.2435 11.6991C17.3119 12.8923 16.9711 14.0731 16.2774 15.0464C15.5838 16.0197 14.5788 16.7272 13.4285 17.0519C12.2783 17.3767 11.0517 17.2992 9.95147 16.8324C8.85123 16.3655 7.94322 15.5372 7.3775 14.4844C6.81178 13.4316 6.62223 12.2172 6.84017 11.0421C7.05811 9.86694 7.67049 8.80133 8.57611 8.02138C9.48173 7.24142 10.6264 6.79382 11.8208 6.75255C13.0153 6.71127 14.1881 7.0788 15.1454 7.79438L17.2782 5.66157C15.7152 4.36388 13.7279 3.68941 11.6979 3.7677C9.66793 3.846 7.73844 4.67153 6.28003 6.08576C4.82163 7.49998 3.93715 9.40317 3.79646 11.4298C3.65578 13.4564 4.26881 15.4635 5.51782 17.0657C6.76683 18.6679 8.56375 19.7521 10.5634 20.1101C12.5631 20.4682 14.6246 20.0747 16.3519 19.0055C18.0792 17.9362 19.3506 16.2664 19.9218 14.3169C20.493 12.3674 20.3238 10.2755 19.4467 8.44313C19.3609 8.26361 19.3499 8.05737 19.4162 7.86978C19.4825 7.68218 19.6206 7.5286 19.8001 7.44282C19.9796 7.35704 20.1859 7.34608 20.3735 7.41237C20.5611 7.47865 20.7146 7.61674 20.8004 7.79626Z"
                fill="currentColor"
              />
            </svg>
            <span>Voltar para coleta de dados</span>
          </button>
          <button
            [ngClass]="selectedTab === 'deliveries' ? 'invisible' : ''"
            class="btn fw-bold text-primary"
            (click)="toggleTab('deliveries')"
          >
            <svg
              class="me-1 mb-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2735_1498)">
                <path
                  d="M21.0001 11.9999C21.0001 12.1988 20.9211 12.3896 20.7804 12.5303C20.6398 12.6709 20.449 12.7499 20.2501 12.7499H5.56041L11.0307 18.2193C11.1004 18.289 11.1557 18.3717 11.1934 18.4628C11.2311 18.5538 11.2505 18.6514 11.2505 18.7499C11.2505 18.8485 11.2311 18.9461 11.1934 19.0371C11.1557 19.1281 11.1004 19.2109 11.0307 19.2806C10.961 19.3502 10.8783 19.4055 10.7873 19.4432C10.6962 19.4809 10.5986 19.5003 10.5001 19.5003C10.4016 19.5003 10.304 19.4809 10.2129 19.4432C10.1219 19.4055 10.0392 19.3502 9.96948 19.2806L3.21948 12.5306C3.14974 12.4609 3.09443 12.3782 3.05668 12.2871C3.01894 12.1961 2.99951 12.0985 2.99951 11.9999C2.99951 11.9014 3.01894 11.8038 3.05668 11.7127C3.09443 11.6217 3.14974 11.539 3.21948 11.4693L9.96948 4.7193C10.1102 4.57857 10.3011 4.49951 10.5001 4.49951C10.6991 4.49951 10.89 4.57857 11.0307 4.7193C11.1715 4.86003 11.2505 5.05091 11.2505 5.24993C11.2505 5.44895 11.1715 5.63982 11.0307 5.78055L5.56041 11.2499H20.2501C20.449 11.2499 20.6398 11.3289 20.7804 11.4696C20.9211 11.6103 21.0001 11.801 21.0001 11.9999Z"
                  fill="#0A5DA1"
                />
              </g>
              <defs>
                <clipPath id="clip0_2735_1498">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>

            Anterior
          </button>
          <button
            class="btn bg-primary fw-bold text-white rounder-1"
            (click)="goToNextPage()"
          >
            Próxima
            <svg
              class="ms-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7806 12.5306L14.0306 19.2806C13.8899 19.4213 13.699 19.5003 13.5 19.5003C13.301 19.5003 13.1101 19.4213 12.9694 19.2806C12.8286 19.1398 12.7496 18.949 12.7496 18.7499C12.7496 18.5509 12.8286 18.36 12.9694 18.2193L18.4397 12.7499H3.75C3.55109 12.7499 3.36032 12.6709 3.21967 12.5303C3.07902 12.3896 3 12.1988 3 11.9999C3 11.801 3.07902 11.6103 3.21967 11.4696C3.36032 11.3289 3.55109 11.2499 3.75 11.2499H18.4397L12.9694 5.78055C12.8286 5.63982 12.7496 5.44895 12.7496 5.24993C12.7496 5.05091 12.8286 4.86003 12.9694 4.7193C13.1101 4.57857 13.301 4.49951 13.5 4.49951C13.699 4.49951 13.8899 4.57857 14.0306 4.7193L20.7806 11.4693C20.8504 11.539 20.9057 11.6217 20.9434 11.7127C20.9812 11.8038 21.0006 11.9014 21.0006 11.9999C21.0006 12.0985 20.9812 12.1961 20.9434 12.2871C20.9057 12.3782 20.8504 12.4609 20.7806 12.5306Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </footer>
    </div>
  </div>
</div>
